export default "__VITE_ASSET__8wSnyMTh__"